import GetfacilityTypeData from './GetfacilityTypeData';

export default function adjustCoordinates(item) {
    if (GetfacilityTypeData(item.type,"mapMarkerType") === 'line') {
        let startLatLng = new window.google.maps.LatLng(item.startLat, item.startLng);
        let endLatLng = new window.google.maps.LatLng(item.endLat, item.endLng);
        // 始点終点が同じ場合、少しずらす（まったく同じだとクリックできなくなる）
        if (startLatLng.equals(endLatLng)) {
            endLatLng = new window.google.maps.LatLng(item.endLat + 0.0000001, item.endLng);
        }
        item.coordinates = [startLatLng, endLatLng];
    }
}